import { OsStatus } from '../../types/os'

export const STATUS_UI: Record<OsStatus, { bg: string; color: string; label: string }> = {
  EM_ABERTO: { bg: '#DBEAFE', color: '#1E40AF', label: 'Em Aberto' },
  EM_PREENCHIMENTO: { bg: '#FEF3C7', color: '#92400E', label: 'Em Preenchimento' },
  AGUARDANDO_APROVACAO: { bg: '#FED7AA', color: '#9A3412', label: 'Aguardando Aprovação' },
  APROVADA: { bg: '#D1FAE5', color: '#065F46', label: 'Aprovada' },
  REJEITADA: { bg: '#FEE2E2', color: '#991B1B', label: 'Rejeitada' },
}

// Status do fechamento no P2 (enum p2_fechamentos.Status).
export const FECHAMENTO_UI: Record<string, { bg: string; color: string; label: string }> = {
  pre_submetido: { bg: '#FEF3C7', color: '#92400E', label: 'Pré-submetido' },
  submetido: { bg: '#DBEAFE', color: '#1E40AF', label: 'Submetido' },
  aprovado_comercial: { bg: '#E0E7FF', color: '#3730A3', label: 'Aprov. Comercial' },
  aprovado_produtor: { bg: '#D1FAE5', color: '#065F46', label: 'Aprov. Produtor' },
}

export const fmtMoney = (v: number | string | null | undefined): string =>
  `R$ ${Number(v ?? 0).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`

export const fmtDate = (d?: string | null): string => {
  if (!d) return '—'
  const m = String(d).match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (m) return `${m[3]}/${m[2]}/${m[1]}`
  const date = new Date(d)
  if (isNaN(date.getTime())) return String(d).split('T')[0].split(' ')[0]
  return date.toLocaleDateString('pt-BR')
}

export const fmtDateTime = (d?: string | null): string => {
  if (!d) return '—'
  const date = new Date(d)
  if (isNaN(date.getTime())) return String(d)
  return date.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
